export type MessageType = 'unauthorizedError';

type Message = { type: Extract<MessageType, 'unauthorizedError'> };

type Subscriber<MT extends MessageType = MessageType> = (
    message: Extract<Message, { type: MT }>
) => void;

const createMessageBroker = () => {
    const subscribers: { [MT in MessageType]?: Set<Subscriber<MT>> } = {};

    const publish = <MT extends MessageType = MessageType>(
        message: Extract<Message, { type: MT }>
    ) => {
        setTimeout(() => {
            subscribers[message.type]?.forEach((subscriber) =>
                (subscriber as Subscriber<MT>)(message)
            );
        });
    };

    const subscribe = <MT extends MessageType = MessageType>(
        messageType: MT,
        subscriber: Subscriber<MT>
    ) => {
        if (!subscribers[messageType]) {
            (subscribers[messageType] as unknown as Set<Subscriber<MT>>) =
                new Set();
        }

        subscribers[messageType]!.add(subscriber);

        return () => unsubscribe(messageType, subscriber);
    };

    const unsubscribe = <MT extends MessageType = MessageType>(
        messageType: MT,
        subscriber: Subscriber<MT>
    ) => {
        subscribers[messageType]?.delete(subscriber);
    };

    return { publish, subscribe, unsubscribe };
};

const messageBroker = createMessageBroker();

export default messageBroker;
